// extracted by mini-css-extract-plugin
export var numpadContainer = "_s7-1";
export var phoneButton = "_s7-0";